import React, { FC } from 'react';

type GoBackButtonProps = {
  onClick: () => void;
  buttonLabel?: string;
}

export const GoBackButton: FC<GoBackButtonProps> = ({
  onClick,
  buttonLabel = "Tilbake"
}) => {
  return (
    <button onClick={onClick} type="button" className="btn link-back react-modal__close ms-n1">
      {buttonLabel}
    </button>
  )
};
